import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { withRouter } from "react-router-dom"
import { connect } from 'react-redux'
import { Redirect }from 'react-router-dom'

// API
import * as API  from '../../utils/api'

// Components
import Header from '../../components/Global/Header'
import ProfileHeader from '../../components/Profile/ProfileHeader'
import Footer from '../../components/Global/Footer'

// Components - Profile Sections
import PlayerProfileProfile from './ProfileSections/PlayerProfileProfile'
import PlayerProfileAwards from './ProfileSections/PlayerProfileAwards'
import PlayerProfileStats from './ProfileSections/PlayerProfileStats'
import PlayerProfileCamps from './ProfileSections/PlayerProfileCamps'
import PlayerProfileContact from './ProfileSections/PlayerProfileContact'

// Actions
import {
  hideModal,
} from '../../actions/modal'

// Packages
import shortid from 'shortid'

class PlayerProfile extends Component {
  static propTypes = {
    path: PropTypes.string.isRequired
  }

  state = {
    profile: {
      first_name: null,
      graduating_year: null,
      height_us_feed: null,
      hudl_username: null,
      last_name: null,
      participations: null,
      school: null,
      sex: null,
      subscribed: null,
      suspended: null,
      trial_info: {
        days_remaining: null,
        on_trial: false,
        trial_active: false,
        trial_coach_views: 0,
        trial_expired: true,
      },
      twitter_username: null,
      username: null,
      weight_lbs: null,
    },
    participation: null,
    selectedParticipation: null,
    selectedSection: null,
    redirectPath: '',
    redirecting: false,
    isLoading: true,
  }

  componentDidMount() {
    this.getProfile(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.getProfile(nextProps)
  }

  getProfile = (passedProps) => {
    API.getProfile(passedProps.username)
    .then(response => {
      if (response.errors && (response.errors[0] === 'Not found')) {
        this.redirectToUrl('/404')
      } else {
        this.initializePlayerProfile(response, passedProps)
      }
    })
  }

  initializePlayerProfile(profile, passedProps) {
    const {
      username,
      sportSlug, // used in URL
      section    // used in URL
    } = passedProps

    // Set the selected participation
    const selectedParticipation = sportSlug
      ? this.getParticipation(sportSlug, profile.participations)
      : profile.participations[0]

    // Set selected section. Default to 'profile'
    // if section is not specified
    const selectedSection = section ? section : 'profile'

    if (!sportSlug || !section) {
      // If sportSlug or section params are missing,
      // redirect to a default url.
      this.redirectToUrl(`/${username}/${selectedParticipation.sport_slug}/${selectedSection}`)
    } else {
      // Otherwise, if both params exist, get all of the participation (sport)
      //  info and set it to state for the profile to use
      if (selectedParticipation) {
        API.getParticipation(selectedParticipation.id)
        .then(participation => {
          this.setState({
            profile,
            participation,
            selectedParticipation,
            selectedSection,
            redirecting: false,
            isLoading: false,
          })
        })
      } else {
        // If the participation doesn't exist, then the URL is incorrect.
        // Redirect to 404 page.
        this.redirectToUrl('/404')
      }
    }
  }

  redirectToUrl = (url) => {
    this.setState({
      redirectPath: url,
      redirecting: true
    })
  }

  getParticipation = (sportSlug, participations) => {
    let selection = participations.filter(participation => {
      return participation.sport_slug === sportSlug
    })

    return selection[0]
  }

  renderSectionContent = (selectedSection) => {
    const { participation } = this.state

    switch (selectedSection) {
      case 'profile':
        return ( <PlayerProfileProfile participation={participation} /> )
        // eslint-disable-next-line no-unreachable
        break
      case 'awards':
        return ( <PlayerProfileAwards {...participation} /> )
        // eslint-disable-next-line no-unreachable
        break
      case 'stats':
        return ( <PlayerProfileStats {...participation} /> )
        // eslint-disable-next-line no-unreachable
        break
      case 'camps':
        return ( <PlayerProfileCamps {...participation} /> )
        // eslint-disable-next-line no-unreachable
        break
      case 'contact':
        return ( <PlayerProfileContact {...participation} /> )
        // eslint-disable-next-line no-unreachable
        break
      default:
        return (
          <div>Placeholder</div>
        )
    }
  }

  getAthleteName() {
    const { profile } = this.state

    return profile
    ? profile.first_name + ' ' + profile.last_name
    : 'Player Profile'
  }

  render() {
    const { appName, path } = this.props

    const {
      profile,
      participation,
      selectedSection,
      selectedParticipation,
      redirectPath,
      redirecting,
      isLoading,
    } = this.state

    if (profile && profile.suspended) return(<Redirect to="/404" />)

    if (redirecting) return (<Redirect to={redirectPath} />)

    if (!isLoading) {

    }

    const subscribed = profile ? profile.subscribed : false
    const trial_active = profile.trial_info ? profile.trial_info.trial_active : false

    return !isLoading && (
      <div className="player-profile">
        {
          profile && participation && <div key={shortid.generate()}>
            <Helmet>
              <title> {this.getAthleteName()} | {appName}</title>
            </Helmet>
            <Header path={ path } />
            <ProfileHeader
              profile={ profile }
              participation={ participation }
              profileNav={ true }
              profileRatings={ subscribed || trial_active ? true : false }
              keyMetrics={ subscribed || trial_active ? true : false }
              profileTabSelect={ subscribed || trial_active ? true : false }
              selectedParticipation={ selectedParticipation }
              selectedSection={ selectedSection }
            />
            { (subscribed || trial_active) &&
              this.renderSectionContent(selectedSection)
            }
            <Footer appName={ appName } />
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeProfile: state.activeProfile,
    modal: state.modal
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideModal: modalType => {
      dispatch(hideModal(modalType))
    },
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerProfile))



// WEBPACK FOOTER //
// ./src/screens/Profile/PlayerProfile.js